import { evaluateBooleanExpression } from "../../shared/utils/expression.utils";
import React, { useMemo, useState } from "react";
import { TextExtractor, findFirstComponentOfType } from "../internal/TextExtractor";

interface IfProps {
  children: React.ReactNode,
}

/***
 * A component that renders its children if a condition is true.
 */
export function If({ children }: IfProps): React.ReactElement {

  // Get the condition from the condition child
  const conditionChild = useMemo(() => findFirstComponentOfType(children, "arg-condition"), [children]);
  const [conditionValue, setConditionValue] = useState("");

  const thenChild = useMemo(() => findFirstComponentOfType(children, "arg-then"), [children]);
  const elseChild = useMemo(() => findFirstComponentOfType(children, "arg-else"), [children]);

  const result = useMemo(() => evaluateBooleanExpression(conditionValue), [conditionValue]);

  return <>
    {conditionChild && (
      <TextExtractor onExtractedText={setConditionValue}>
        {conditionChild?.props.children}
      </TextExtractor>
    )}
    {result ? thenChild?.props.children : elseChild?.props.children}
  </>;
}

